export const userKeys = {
    all: ['users'] as const,
    list: () => [...userKeys.all, 'list'] as const,
    projectContacts: () => [...userKeys.all, 'project-contacts'] as const,
}
